import { Ref } from 'vue';
import { updateMultiple } from '@/ui/queryState';
import { PaginationResetCallback } from '@/ui/types';
import { freeTagField } from '../form/FreeTagField';

export const freeTagFilter = ({
  value,
  name,
  label,
  placeholder,
  reset,
  hideLabel,
  horizontal,
}: {
  value: Ref<string[]>;
  name: string;
  label: string;
  placeholder: string;
  reset: PaginationResetCallback;
  hideLabel?: boolean;
  horizontal?: boolean;
}) => freeTagField(
  {
    value: value.value,
    name,
    label,
    placeholder: value.value.length > 0 ? '' : placeholder,
    required: false,
    errors: [],
    disabled: false,
    hideLabel,
    horizontal,
  },
  v => updateMultiple(() => {
    reset();
    value.value = v;
  }, true),
);
